import { WarehouseLocationGroupUpdatePage } from '@/features/warehouse-location-group/pages/WarehouseLocationGroupUpdatePage';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/warehouse-location-group/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["warehouse_location_group.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: WarehouseLocationGroupUpdatePage,
})
